import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { IconButton } from "@material-ui/core";
import { selectCurrentLocation, selectCurrentLocationId } from "../../../store/locationStore/locationSelectors";
import HorizontalPanel from "../../../components/HorizontalPanel";
import { Toolbar } from "../../../app/components";
import { pagePathGenerator } from "../../../routes/pagePathGenerator";
import MiniMapContainer from "../../Map/MiniMapContainer";
import WifiTethering from "@material-ui/icons/WifiTethering";
import FullscreenIcon from "@material-ui/icons/Fullscreen";
import FrequencyAnalysisLinkIcon from "../../FrequencyAnalysisPage/FrequencyAnalysisLinkIcon";

const LocationSmallMapPanel = () => {
  const history = useHistory();
  const currentLocation = useSelector(selectCurrentLocation)
  const currentLocationId = useSelector(selectCurrentLocationId);
  const mapDisabled = !currentLocationId || currentLocationId === -1

  const onMapClick = () => {
    if (mapDisabled) {
      return;
    }

    const url = pagePathGenerator.MAP_PAGE({
      locationId: currentLocationId,
    });

    history.push(url);
  }

  const onDevicesMapClick = () => {
    const devicesMapUrl = pagePathGenerator.DEVICES_MAP({ mapId: currentLocation?.mapId });
    history.push(devicesMapUrl);
  }

  return (
    <HorizontalPanel size={HorizontalPanel.SIZES.WHOLE_SPACE}>
      <HorizontalPanel size={HorizontalPanel.SIZES.SMALL}>
        <Toolbar title='Location map'>
          <IconButton
            aria-label='open device map'
            color='secondary'
            size='small'
            onClick={onDevicesMapClick}
          >
            <WifiTethering />
          </IconButton>
          <IconButton
            disabled={mapDisabled}
            aria-label='location map'
            color='secondary'
            size='small'
            onClick={onMapClick}
          >
            <FullscreenIcon />
          </IconButton>
          <FrequencyAnalysisLinkIcon
            mapId={currentLocation?.mapId}
          />
        </Toolbar>
      </HorizontalPanel>
      <MiniMapContainer
        map={currentLocation?.map}
      />
    </HorizontalPanel>
  )
}

export default LocationSmallMapPanel;